import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

//Material UI
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Grid } from '@material-ui/core';

//Zustands
import { useOnlineUsersStore } from './useOnlineUsersStore';
import { useMainStore } from 'useStores/useMainStore';

//Packages
import { isMobile } from 'react-device-detect';
import { useMutation, useQuery } from 'react-query';
import moment from 'moment-jalaali';

//Hooks
import { getSpeceficUser } from 'useReactQueries/useOnlineUsers';
//Components
import DatePicker from 'components/TextFields/DatePicker';
import Accordion from '../../../../../components/Accordion/Accordion';

const useStyles = makeStyles((theme) => ({
  searchButton: {
    width: 150,
  },
}));

const UserDetailsFilters = () => {
  const classes = useStyles();
  const page = useOnlineUsersStore((state) => state.userPage);
  const changeUserStartDate = useOnlineUsersStore(
    (state) => state.changeStartDate
  );
  const changeUserEndDate = useOnlineUsersStore((state) => state.changeEndDate);
  const startDate = useOnlineUsersStore((state) => state.startDate);
  const endDate = useOnlineUsersStore((state) => state.endDate);
  const setUsers = useOnlineUsersStore((state) => state.setSelectedUser);
  const isLoading = useOnlineUsersStore((state) => state.isLoadingUser);
  const setLoading = useOnlineUsersStore((state) => state.setUserLoading);
  const limit = useMainStore((state) => state.limit);
  const firstRender = useRef(true);
  const { id } = useParams();

  const { mutate } = useMutation(getSpeceficUser, {
    onSuccess: (result) => {
      setUsers(result);
      setLoading(false);
    },
    onMutate: () => {
      setLoading(true);
    },
  });

  const handleClickSearchButton = () => {
    mutate({
      userId: id,
      page,
      limit,
      from: moment(startDate)?.format('YYYY-MM-DD'),
      to: moment(endDate)?.format('YYYY-MM-DD'),
    });
  };

  useEffect(() => {
    if (firstRender.current) {
      handleClickSearchButton();

      firstRender.current = false;
    } else {
      handleClickSearchButton();
    }
  }, [page, limit]);

  return (
    <Accordion title="فیلترها" open={isMobile ? false : true}>
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12} md={6} className="d-flex " style={{ gap: 8 }}>
          <DatePicker
            label="ازتاریخ"
            value={startDate}
            onChange={changeUserStartDate}
          />
          <DatePicker
            label="تا‌تاریخ"
            value={endDate}
            onChange={changeUserEndDate}
          />
        </Grid>

        <Grid item justify="flex-end" className="d-flex" xs={12} md={6}>
          <Box className={classes.spacer} />
          <Button
            color="secondary"
            variant="contained"
            className={classes.searchButton}
            onClick={handleClickSearchButton}
            disabled={isLoading}
          >
            {isLoading ? 'در حال جستجو ...' : 'جستجو'}
          </Button>
        </Grid>
      </Grid>
    </Accordion>
  );
};

export default UserDetailsFilters;
